import { Accordion, Form } from "react-bootstrap";
import SimpleBar from "simplebar-react";
export const KmlToolbox = ({kmlData, selectedKmlData, isSelectAllChecked, handleSelectAll, handleSelectionUpdate}) => {
    return <Accordion.Item eventKey='2'>
        <Accordion.Header><i className='fi-code me-2' /> KML</Accordion.Header>
        <Accordion.Body>
            {kmlData.length > 1 && <Form.Check id="select-all-kml" value={isSelectAllChecked} checked={isSelectAllChecked} onChange={e => handleSelectAll(e)} label={<><span className='fs-sm fw-bold'>All</span></>} />}
            <SimpleBar autoHide={false} className='simplebar-no-autohide' style={{ maxHeight: '11rem' }}>                        
                {kmlData.map(item => (
                    <Form.Check 
                        id={item.id}
                        checked={selectedKmlData.includes(item.id)}
                        key={item.id} 
                        value={item.id} 
                        onChange={e => handleSelectionUpdate(e, item)} 
                        label={<><span className='fs-sm'>{item.fileName}</span></>} 
                    />
                ))} 
            </SimpleBar>
        </Accordion.Body>
    </Accordion.Item>
}